import { PageFooterComponents } from '@my-types';
import { React, Styled } from '@common/3rd';
import { PageFooter } from '@component';

const Footer = Styled.div.attrs({ 'data-widget': 'page-footer' })`
	width: 100vw;
	padding: 50px 0;
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #eee;
	> div:nth-child(1) {
		padding-right: 30px;
		p:first-child {
			font-size: ${props => props.theme.FONT_SIZE_L2}px;
			font-weight: 400;
		}
		p:last-child {
			font-size: ${props => props.theme.FONT_SIZE_SMALL}px;
			line-height: 1;
		}
	}
	> div:nth-child(2), > div:nth-child(3) {
		padding: 20px 40px;
		border-left: 1px solid #ddd;
		color: #999;
		line-height: 1.5;
	}
	> div:nth-child(3) {
		padding-right: 0;
	}
`
/**
 * 桌面页脚
 */
class DeskPageFooter<P, S, C extends PageFooterComponents> extends PageFooter<
	P,
	S,
	C
> {
	render() {
		return (
			<Footer>
				<div>
					<p>广东对外贸易与投资企业风险管控平台</p>
					<p>Risk Management Platform for Foreign Trade and<br/> Investment Enterprises of Guangdong Province</p>
				</div>
				<div>
					联系电话：<br/>
					020-38191787<br/>
					020-38191788<br/>
					020-38191789
				</div>
				<div>
					版权所有 Copyright &copy; {(new Date()).getFullYear()} 长城保险经纪有限公司 All Rights Reserved<br/>
					粤ICP备05081596号<br/>
					信息系统安全等级保护备案 第三级 4401152800400001
				</div>
			</Footer>
		);
	}
}

export default DeskPageFooter;
